<template>
    <div class="page quiz-view-page">
        <div class="page-header">
            <div class="page-header-content">
                <h1>
                    查看測驗{{ viewData?.name ? ` - ${viewData.name}` : '' }}
                </h1>
                <a-button
                    type="text"
                    class="header-back-button"
                    @click="goBack"
                >
                    返回
                </a-button>
            </div>
        </div>

        <div v-if="!loading && viewData" class="content-container">
            <a-row :gutter="24">
                <!-- 左側：測驗基本資訊 -->
                <a-col :span="7">
                    <div class="info-card quiz-info-card">
                        <div class="card-title-wrapper">
                            <h3 class="card-title">
                                {{ viewData?.name || '測驗資訊' }}
                            </h3>
                            <a-tag
                                v-if="viewData?.scoring_mode_display"
                                class="scoring-mode-tag"
                                :color="
                                    getScoringModeColor(viewData.scoring_mode)
                                "
                            >
                                {{ viewData.scoring_mode_display }}
                            </a-tag>
                        </div>
                        <div class="info-content">
                            <div class="info-item">
                                <div class="info-label">說明</div>
                                <div class="info-value description-value">
                                    {{ viewData?.description || '-' }}
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">狀態</div>
                                <div class="info-value">
                                    {{ viewData?.status_display || '-' }}
                                </div>
                            </div>

                            <div
                                v-if="
                                    viewData?.scoring_mode !== 'survey' &&
                                    viewData?.scoring_mode !== 'dimensions'
                                "
                                class="info-item"
                            >
                                <div class="info-label">總分</div>
                                <div class="info-value">
                                    {{ viewData?.total_score || '-' }}
                                </div>
                            </div>

                            <div
                                v-if="viewData?.scoring_mode === 'normal'"
                                class="info-item"
                            >
                                <div class="info-label">及格分數</div>
                                <div class="info-value">
                                    {{ viewData?.passing_score || '-' }}
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">時間限制</div>
                                <div class="info-value">
                                    {{ viewData?.time_limit_display || '-' }}
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">最大作答次數</div>
                                <div class="info-value">
                                    {{
                                        viewData?.max_attempts_per_user ||
                                        viewData?.max_attempts_per_user === 0
                                            ? viewData.max_attempts_per_user ===
                                              0
                                                ? '無限制'
                                                : viewData.max_attempts_per_user
                                            : '-'
                                    }}
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">總作答次數</div>
                                <div class="info-value">
                                    {{ viewData?.total_attempts || 0 }}
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">已完成次數</div>
                                <div class="info-value">
                                    {{ viewData?.completed_attempts || 0 }}
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">建立者</div>
                                <div class="info-value">
                                    {{ viewData?.created_by || '-' }}
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">建立時間</div>
                                <div class="info-value">
                                    {{ viewData?.created_at || '-' }}
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">更新者</div>
                                <div class="info-value">
                                    {{ viewData?.updated_by || '-' }}
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">更新時間</div>
                                <div class="info-value">
                                    {{ viewData?.updated_at || '-' }}
                                </div>
                            </div>

                            <!-- 維度類型：顯示維度列表（小卡片呈現） -->
                            <div
                                v-if="
                                    viewData?.scoring_mode === 'dimensions' &&
                                    viewData?.dimensions &&
                                    viewData.dimensions.length > 0
                                "
                                class="info-item dimensions-info-item"
                            >
                                <div class="info-label-wrapper">
                                    <div class="info-label">維度列表</div>
                                    <a-button
                                        type="primary"
                                        size="small"
                                        class="view-results-btn"
                                        @click="showResultCardsModal = true"
                                    >
                                        查看結果卡
                                    </a-button>
                                </div>
                                <div class="dimensions-cards-list">
                                    <div
                                        v-for="dimension in viewData.dimensions"
                                        :key="dimension.id"
                                        class="dimension-card"
                                    >
                                        <div class="dimension-card-header">
                                            <div class="dimension-card-name">
                                                {{
                                                    dimension.name ||
                                                    `維度${dimension.sequence || ''}`
                                                }}
                                            </div>
                                            <div
                                                v-if="dimension.description"
                                                class="dimension-card-description"
                                            >
                                                {{ dimension.description }}
                                            </div>
                                        </div>
                                        <div class="dimension-card-content">
                                            <div
                                                class="dimension-weights-summary"
                                            >
                                                <div
                                                    v-for="(
                                                        weightData, idx
                                                    ) in getDimensionWeightsSummary(
                                                        dimension.id
                                                    )"
                                                    :key="idx"
                                                    class="weight-summary-item"
                                                >
                                                    <span
                                                        class="weight-question-label"
                                                    >
                                                        {{
                                                            weightData.questionTitle
                                                        }}
                                                    </span>
                                                    <span
                                                        class="weight-option-label"
                                                    >
                                                        {{
                                                            weightData.optionLabel
                                                        }}
                                                    </span>
                                                    <span class="weight-value">
                                                        {{ weightData.weight }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a-col>

                <!-- 右側：題目列表（結果卡改由上方按鈕開啟模態框顯示，不在此佔版面） -->
                <a-col :span="17">
                    <div class="questions-container">
                        <div
                            v-for="(q, idx) in viewData?.questions || []"
                            :key="q.id"
                            class="question-card"
                        >
                            <div class="question-header">
                                <h3 class="question-title">
                                    題目 {{ idx + 1 }}
                                </h3>
                                <div class="question-header-right">
                                    <div
                                        v-if="
                                            viewData?.scoring_mode !==
                                                'survey' &&
                                            getQuestionScore(q) !== null
                                        "
                                        class="question-score-badge"
                                    >
                                        {{ getQuestionScore(q) }} 分
                                    </div>
                                    <div class="question-tags">
                                        <a-tag
                                            :color="
                                                q?.question_type === 'single'
                                                    ? '#3b6ea5'
                                                    : '#2a4a7a'
                                            "
                                        >
                                            {{
                                                q?.question_type === 'single'
                                                    ? '單選'
                                                    : q?.question_type ===
                                                        'multiple'
                                                      ? '多選'
                                                      : q?.question_type ===
                                                          'text'
                                                        ? '文字'
                                                        : '數字'
                                            }}
                                        </a-tag>
                                        <a-tag
                                            v-if="q?.is_required"
                                            color="#ff7875"
                                        >
                                            必填
                                        </a-tag>
                                        <a-tag
                                            v-if="
                                                viewData?.scoring_mode !==
                                                'survey'
                                            "
                                            :color="
                                                q?.scoring_mode === 'manual'
                                                    ? '#ffa87a'
                                                    : '#9BB7D4'
                                            "
                                        >
                                            {{
                                                q?.scoring_mode === 'manual'
                                                    ? '人工'
                                                    : '自動'
                                            }}
                                        </a-tag>
                                    </div>
                                </div>
                            </div>

                            <div class="question-body">
                                <div class="question-content-row">
                                    <div class="question-field">
                                        <div class="field-label">問題</div>
                                        <div class="field-value">
                                            {{ q?.title || '-' }}
                                        </div>
                                    </div>

                                    <div
                                        v-if="q?.description"
                                        class="question-field"
                                    >
                                        <div class="field-label">說明</div>
                                        <div class="field-value">
                                            {{ q.description }}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    v-if="
                                        (q?.question_type === 'single' ||
                                            q?.question_type === 'multiple' ||
                                            q?.question_type === 'scale') &&
                                        q?.options &&
                                        q.options.length > 0
                                    "
                                    class="options-section"
                                >
                                    <div class="options-title">選項</div>
                                    <div class="options-list">
                                        <div
                                            v-for="(
                                                option, optIdx
                                            ) in q.options"
                                            :key="option.id || optIdx"
                                            class="option-item"
                                            :class="{
                                                'option-correct':
                                                    isCorrectOption(q, option)
                                            }"
                                        >
                                            <!-- 選項類型指示器（維度類型時隱藏） -->
                                            <div
                                                v-if="
                                                    viewData?.scoring_mode !==
                                                    'dimensions'
                                                "
                                                class="option-indicator"
                                            >
                                                <div
                                                    class="option-shape"
                                                    :class="{
                                                        'shape-circle':
                                                            q?.question_type ===
                                                            'single',
                                                        'shape-square':
                                                            q?.question_type ===
                                                            'multiple',
                                                        'shape-selected':
                                                            isCorrectOption(
                                                                q,
                                                                option
                                                            )
                                                    }"
                                                >
                                                    <span
                                                        v-if="
                                                            isCorrectOption(
                                                                q,
                                                                option
                                                            )
                                                        "
                                                        class="shape-check"
                                                    >
                                                        ✓
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="option-main">
                                                <div class="option-label">
                                                    {{ option?.label || '' }}
                                                    <span
                                                        v-if="
                                                            isCorrectOption(
                                                                q,
                                                                option
                                                            ) &&
                                                            viewData?.scoring_mode !==
                                                                'dimensions'
                                                        "
                                                        class="correct-checkmark"
                                                    >
                                                        ✓
                                                    </span>
                                                    <span
                                                        v-if="
                                                            isCorrectOption(
                                                                q,
                                                                option
                                                            ) &&
                                                            getOptionScore(
                                                                q,
                                                                option
                                                            ) !== null &&
                                                            viewData?.scoring_mode !==
                                                                'dimensions'
                                                        "
                                                        class="score-text-inline"
                                                    >
                                                        {{
                                                            getOptionScore(
                                                                q,
                                                                option
                                                            )
                                                        }}
                                                        分
                                                    </span>
                                                </div>

                                                <!-- 維度類型：顯示維度加權（每個選項下方） -->
                                                <div
                                                    v-if="
                                                        viewData?.scoring_mode ===
                                                            'dimensions' &&
                                                        viewData?.dimensions &&
                                                        viewData.dimensions
                                                            .length > 0 &&
                                                        option?.weights &&
                                                        Array.isArray(
                                                            option.weights
                                                        )
                                                    "
                                                    class="option-dimension-weights"
                                                >
                                                    <div
                                                        v-for="dimension in viewData.dimensions"
                                                        :key="dimension.id"
                                                        class="dimension-weight-item"
                                                    >
                                                        <span
                                                            class="dimension-weight-label"
                                                        >
                                                            {{
                                                                dimension.name ||
                                                                `維度${dimension.sequence || ''}`
                                                            }}
                                                        </span>
                                                        <span
                                                            class="dimension-weight-value"
                                                        >
                                                            {{
                                                                getDimensionWeight(
                                                                    option,
                                                                    dimension.id
                                                                )
                                                            }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- 文字題答案顯示 -->
                                <div
                                    v-if="
                                        (q?.question_type === 'text' ||
                                            q?.question_type === 'long_text' ||
                                            q?.question_type === 'number') &&
                                        hasAnswer(q)
                                    "
                                    class="text-answer-section"
                                >
                                    <div class="text-answer-inline">
                                        <span class="answer-checkmark">✓</span>
                                        <span class="text-answer-value">
                                            {{ getTextAnswer(q) }}
                                        </span>
                                    </div>
                                </div>

                                <!-- 顯示未設置答案提示（問卷模式不需要，人工審核模式不需要，維度模式不需要） -->
                                <div
                                    v-if="
                                        !hasAnswer(q) &&
                                        viewData?.scoring_mode !== 'survey' &&
                                        viewData?.scoring_mode !==
                                            'dimensions' &&
                                        q?.scoring_mode !== 'manual'
                                    "
                                    class="no-answer-hint"
                                >
                                    <span class="no-answer-text">
                                        尚未設置答案
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div
                            v-if="
                                !viewData?.questions ||
                                viewData.questions.length === 0
                            "
                            class="empty-questions"
                        >
                            <div class="empty-icon">📝</div>
                            <div class="empty-text">尚無題目</div>
                        </div>
                    </div>
                </a-col>
            </a-row>
        </div>

        <!-- 結果卡模態框 -->
        <a-modal
            v-model:open="showResultCardsModal"
            title="結果卡"
            :width="1200"
            :footer="null"
            class="result-cards-modal"
        >
            <div
                v-if="resultCards && resultCards.length > 0"
                class="result-cards-modal-content"
            >
                <div class="result-cards-grid-modal">
                    <div
                        v-for="resultCard in resultCards"
                        :key="resultCard.id"
                        class="result-card-item-modal"
                    >
                        <div
                            v-if="resultCard.image_url"
                            class="result-card-image-wrapper-modal"
                        >
                            <img
                                :src="resultCard.image_url"
                                :alt="resultCard.title"
                                class="result-card-image-modal"
                            />
                        </div>
                        <div class="result-card-content-modal">
                            <h4 class="result-card-title-modal">
                                {{ resultCard.title }}
                            </h4>
                            <div class="result-card-meta-modal">
                                <a-tag
                                    v-if="resultCard.target_dimension_name"
                                    color="#a896b8"
                                >
                                    {{ resultCard.target_dimension_name }}
                                </a-tag>
                                <span
                                    v-if="resultCard.select_mode_display"
                                    class="result-card-select-mode-modal"
                                >
                                    {{ resultCard.select_mode_display }}
                                </span>
                            </div>
                            <p
                                v-if="resultCard.subtitle"
                                class="result-card-subtitle-modal"
                            >
                                {{ resultCard.subtitle }}
                            </p>
                            <p
                                v-if="resultCard.summary"
                                class="result-card-summary-modal"
                            >
                                {{ resultCard.summary }}
                            </p>
                            <div
                                v-if="resultCard.detail_html"
                                class="result-card-detail-html"
                                v-html="sanitizeHtml(resultCard.detail_html)"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="no-result-cards">
                <p>暫無結果卡</p>
            </div>
        </a-modal>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, watch } from 'vue';
import { message } from 'ant-design-vue';
import { showErrorMessage } from '@/utils/messageHelper';
import { sanitizeHtml } from '@/utils/sanitizeHtml';
import { ReloadOutlined } from '@ant-design/icons-vue';
import { getSingleQuiz, getQuizResults } from '@/api/quiz';
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();
const { params } = route;
const { id } = params;
const loading = ref(false);

const viewData = ref(null);
const resultCards = ref([]);
const showResultCardsModal = ref(false);

// 判斷選項是否為正確答案
const isCorrectOption = (question, option) => {
    if (!question || !option) return false;

    // 選項題（single, multiple）：檢查 correct_answers 陣列
    if (
        question?.question_type === 'single' ||
        question?.question_type === 'multiple' ||
        question?.question_type === 'scale'
    ) {
        if (
            question.correct_answers &&
            Array.isArray(question.correct_answers) &&
            question.correct_answers.length > 0
        ) {
            return question.correct_answers.some(
                (ans) => ans?.option_id === option.id
            );
        }
    }
    return false;
};

// 取得選項的分數
const getOptionScore = (question, option) => {
    if (!question || !option) return null;

    if (
        question?.question_type === 'single' ||
        question?.question_type === 'multiple' ||
        question?.question_type === 'scale'
    ) {
        if (
            question.correct_answers &&
            Array.isArray(question.correct_answers)
        ) {
            const answer = question.correct_answers.find(
                (ans) => ans?.option_id === option.id
            );
            return answer?.score !== null && answer?.score !== undefined
                ? answer.score
                : null;
        }
    }
    return null;
};

// 取得題目的正確答案（用於文字題）
const getTextAnswer = (question) => {
    if (!question) return null;

    if (
        question?.question_type === 'text' ||
        question?.question_type === 'long_text' ||
        question?.question_type === 'number'
    ) {
        return question.correct_answer || null;
    }
    return null;
};

// 取得文字題的分數
const getTextAnswerScore = (question) => {
    if (!question) return null;

    if (
        question?.question_type === 'text' ||
        question?.question_type === 'long_text' ||
        question?.question_type === 'number'
    ) {
        // 檢查是否有答案陣列，從中取得分數
        if (
            question.answers &&
            Array.isArray(question.answers) &&
            question.answers.length > 0
        ) {
            const score =
                Number(question.answers[0]?.score) ||
                Number(question.answers[0]?.point) ||
                null;
            if (score !== null) return score;
        }

        // 檢查題目層級的 score
        if (question.score !== null && question.score !== undefined) {
            return Number(question.score);
        }

        // 檢查 max_score
        if (question.max_score) {
            return Number(question.max_score);
        }
    }
    return null;
};

// 檢查題目是否有設置答案
const hasAnswer = (question) => {
    if (!question) return false;

    // 選項題
    if (
        question?.question_type === 'single' ||
        question?.question_type === 'multiple' ||
        question?.question_type === 'scale'
    ) {
        return (
            question.correct_answers &&
            Array.isArray(question.correct_answers) &&
            question.correct_answers.length > 0
        );
    }

    // 文字題
    if (
        question?.question_type === 'text' ||
        question?.question_type === 'long_text' ||
        question?.question_type === 'number'
    ) {
        return (
            question.correct_answer !== null &&
            question.correct_answer !== undefined &&
            String(question.correct_answer).trim() !== ''
        );
    }

    return false;
};

// 取得題目的總分數
const getQuestionScore = (question) => {
    if (!question) return null;

    // 人工審核模式：使用題目層級的分數
    if (question?.scoring_mode === 'manual') {
        if (question.score !== null && question.score !== undefined) {
            return Number(question.score);
        }
        if (question.max_score) {
            return Number(question.max_score);
        }
        return null;
    }

    // 自動計分模式：計算所有正確答案的分數總和
    if (
        question?.question_type === 'single' ||
        question?.question_type === 'multiple' ||
        question?.question_type === 'scale'
    ) {
        if (
            question.correct_answers &&
            Array.isArray(question.correct_answers) &&
            question.correct_answers.length > 0
        ) {
            const totalScore = question.correct_answers.reduce((sum, ans) => {
                const score = Number(ans.score) || Number(ans.point) || 0;
                return sum + score;
            }, 0);
            return totalScore > 0 ? totalScore : null;
        }
        return null;
    }

    // 文字題：使用文字題的分數
    if (
        question?.question_type === 'text' ||
        question?.question_type === 'long_text' ||
        question?.question_type === 'number'
    ) {
        return getTextAnswerScore(question);
    }

    return null;
};

// 返回按鈕處理
// 獲取計分模式顏色（Morandi 色系）
const getScoringModeColor = (scoringMode) => {
    // Morandi 色系：莫蘭迪藍、莫蘭迪黃、莫蘭迪綠
    // 同時支援英文和中文格式
    const colorMap = {
        normal: '#3b6ea5', // Morandi 藍（測驗）
        '測驗': '#3b6ea5',
        dimensions: '#B8A05A', // Morandi 黃（多維）
        '多維': '#B8A05A',
        '維度': '#B8A05A',
        survey: '#9BB7D4', // Morandi 綠（問卷）
        '問卷': '#9BB7D4'
    };
    return colorMap[scoringMode] || 'default';
};

const goBack = () => {
    router.push({
        name: 'QuizzesManagement'
    });
};

// 獲取某個維度的所有加權資料摘要
const getDimensionWeightsSummary = (dimensionId) => {
    if (!viewData.value || !viewData.value.questions) {
        return [];
    }

    const summary = [];
    const questions = viewData.value.questions || [];

    questions.forEach((question, qIdx) => {
        if (
            question.options &&
            Array.isArray(question.options) &&
            question.options.length > 0
        ) {
            question.options.forEach((option) => {
                const weight = getDimensionWeight(option, dimensionId);
                if (weight && Number(weight) > 0) {
                    summary.push({
                        questionTitle: `題目 ${qIdx + 1}`,
                        optionLabel: option.label || '',
                        weight: weight
                    });
                }
            });
        }
    });

    return summary;
};

// 獲取維度加權值（確保類型一致性，用於顯示）
const getDimensionWeight = (option, dimensionId) => {
    if (!option || !option.weights) {
        return '0.00';
    }

    // 如果 weights 是陣列（從 API 載入），轉換為物件格式
    let weightsObj = {};
    if (Array.isArray(option.weights)) {
        option.weights.forEach((weightItem) => {
            if (
                weightItem.dimension_id !== undefined &&
                weightItem.dimension_id !== null &&
                weightItem.weight !== undefined &&
                weightItem.weight !== null
            ) {
                const dimId =
                    typeof weightItem.dimension_id === 'number'
                        ? weightItem.dimension_id
                        : Number(weightItem.dimension_id);
                const weight =
                    typeof weightItem.weight === 'number'
                        ? weightItem.weight
                        : Number(weightItem.weight);
                if (!isNaN(dimId) && !isNaN(weight)) {
                    weightsObj[dimId] = weight;
                }
            }
        });
    } else if (typeof option.weights === 'object') {
        weightsObj = option.weights;
    }

    // 嘗試多種鍵值類型匹配
    const idNum = Number(dimensionId);
    const idStr = String(dimensionId);

    // 優先使用數字鍵
    if (
        !isNaN(idNum) &&
        weightsObj[idNum] !== undefined &&
        weightsObj[idNum] !== null
    ) {
        return Number(weightsObj[idNum]).toFixed(2);
    }

    // 嘗試字串鍵
    if (weightsObj[idStr] !== undefined && weightsObj[idStr] !== null) {
        return Number(weightsObj[idStr]).toFixed(2);
    }

    // 嘗試直接匹配
    if (
        weightsObj[dimensionId] !== undefined &&
        weightsObj[dimensionId] !== null
    ) {
        return Number(weightsObj[dimensionId]).toFixed(2);
    }

    return '0.00';
};

// 載入測驗內容
const loadSingleQuiz = async () => {
    try {
        loading.value = true;

        // 使用 answers 來獲取答案資料
        const response = await getSingleQuiz(id, 'answers');

        if (response.result) {
            viewData.value = response.data;

            // 如果是維度模式，載入結果卡
            if (
                viewData.value?.scoring_mode === 'dimensions' ||
                viewData.value?.scoring_mode === '多維' ||
                viewData.value?.scoring_mode === '維度'
            ) {
                try {
                    const resultsResponse = await getQuizResults(id);
                    if (resultsResponse.result) {
                        const resultsData =
                            resultsResponse?.data?.data ||
                            resultsResponse?.data ||
                            [];
                        resultCards.value = Array.isArray(resultsData)
                            ? resultsData
                            : [];
                    }
                } catch (error) {
                    console.error('載入結果卡失敗:', error);
                }
            }
        } else {
            showErrorMessage(response.message || '載入失敗');
        }
    } catch (error) {
        showErrorMessage('載入測驗清單失敗');
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    loadSingleQuiz();
});
</script>

<style scoped>
.quiz-view-page {
    padding: 24px;
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95),
        rgba(248, 249, 250, 0.9)
    );
    min-height: 100vh;
}

.page-header {
    margin-bottom: 32px;
}

.page-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-header h1 {
    font-size: 28px;
    font-weight: 700;
    margin: 0;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    text-shadow: 0 0 10px rgba(42, 74, 122, 0.3);
}

.header-back-button {
    font-family: 'Courier New', monospace !important;
    font-weight: 600 !important;
    color: rgba(42, 42, 58, 0.85) !important;
    transition: all 0.3s ease !important;
}

.header-back-button:hover {
    color: #3b6ea5 !important;
    background: rgba(138, 175, 255, 0.05) !important;
}

.content-container {
    background: transparent;
}

/* 資訊卡片樣式 */
.info-card {
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95),
        rgba(248, 249, 250, 0.9)
    );
    border-radius: 16px;
    padding: 24px;
    box-shadow:
        0 8px 24px rgba(42, 74, 122, 0.15),
        0 0 0 1px rgba(42, 74, 122, 0.1);
    backdrop-filter: blur(10px);
}

.quiz-info-card {
    position: sticky;
    top: 24px;
}

.card-title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 24px 0;
    padding-bottom: 16px;
    border-bottom: 2px solid rgba(42, 74, 122, 0.3);
}

.card-title {
    font-size: 20px;
    font-weight: 600;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    margin: 0;
}

.mode-tag {
    font-family: 'Courier New', monospace !important;
    font-weight: 600 !important;
    padding: 4px 12px !important;
    border-radius: 6px !important;
    background: linear-gradient(
        135deg,
        rgba(42, 74, 122, 0.15),
        rgba(138, 175, 255, 0.15)
    ) !important;
    border: 1px solid rgba(42, 74, 122, 0.3) !important;
    color: #2a4a7a !important;
}

.info-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.info-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.info-label-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.view-results-btn {
    font-family: 'Courier New', monospace !important;
    font-weight: 600 !important;
    background: linear-gradient(45deg, #2a4a7a, #3b6ea5) !important;
    border: none !important;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.3) !important;
    transition: all 0.3s ease !important;
}

.view-results-btn:hover {
    transform: translateY(-2px) !important;
    box-shadow: 0 4px 12px rgba(42, 74, 122, 0.4) !important;
}

.info-label {
    font-size: 12px;
    font-weight: 600;
    color: rgba(42, 42, 58, 0.6);
    font-family: 'Courier New', monospace;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.info-value {
    font-size: 16px;
    font-weight: 500;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
}

.description-value {
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-word;
}

/* 題目容器 */
/* 結果卡區塊樣式 */
.result-cards-section {
    margin-bottom: 32px;
}

.section-title {
    font-size: 20px;
    font-weight: 700;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid rgba(42, 74, 122, 0.3);
}

.result-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
}

.result-card-item {
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95),
        rgba(248, 249, 250, 0.9)
    );
    border-radius: 16px;
    padding: 20px;
    box-shadow:
        0 8px 24px rgba(42, 74, 122, 0.15),
        0 0 0 1px rgba(42, 74, 122, 0.1);
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
}

.result-card-item:hover {
    transform: translateY(-4px);
    box-shadow:
        0 12px 32px rgba(42, 74, 122, 0.25),
        0 0 0 1px rgba(42, 74, 122, 0.2);
}

.result-card-image-wrapper {
    width: 100%;
    margin-bottom: 16px;
    border-radius: 12px;
    overflow: hidden;
    background: rgba(42, 74, 122, 0.05);
}

.result-card-image {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
}

.result-card-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.result-card-title {
    font-size: 18px;
    font-weight: 700;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    margin: 0;
}

.result-card-subtitle {
    font-size: 14px;
    color: rgba(42, 42, 58, 0.7);
    font-family: 'Courier New', monospace;
    margin: 0;
    line-height: 1.6;
}

.result-card-summary {
    font-size: 13px;
    color: rgba(42, 42, 58, 0.6);
    font-family: 'Courier New', monospace;
    margin: 0;
    line-height: 1.6;
}

.result-card-dimension {
    margin-top: 8px;
}

.questions-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.question-card {
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95),
        rgba(248, 249, 250, 0.9)
    );
    border-radius: 16px;
    padding: 24px;
    box-shadow:
        0 8px 24px rgba(42, 74, 122, 0.15),
        0 0 0 1px rgba(42, 74, 122, 0.1);
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
}

.question-card:hover {
    box-shadow:
        0 12px 32px rgba(42, 74, 122, 0.2),
        0 0 0 1px rgba(42, 74, 122, 0.2);
    transform: translateY(-2px);
}

.question-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(42, 74, 122, 0.15);
    position: relative;
}

.question-header-right {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-direction: column;
}

.question-score-badge {
    font-family: 'Courier New', monospace;
    font-size: 14px;
    font-weight: 700;
    color: #2a4a7a;
    background: rgba(42, 74, 122, 0.1);
    padding: 4px 12px;
    border-radius: 8px;
    border: 1px solid rgba(42, 74, 122, 0.3);
    white-space: nowrap;
}

.question-title {
    font-size: 16px;
    font-weight: 600;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    margin: 0;
}

.question-tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.question-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.question-content-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    align-items: start;
}

.question-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.field-label {
    font-size: 12px;
    font-weight: 600;
    color: rgba(42, 42, 58, 0.6);
    font-family: 'Courier New', monospace;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.field-value {
    font-size: 16px;
    font-weight: 500;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    line-height: 1.6;
}

.options-section {
    margin-top: 8px;
}

.options-title {
    font-size: 14px;
    font-weight: 600;
    color: rgba(42, 42, 58, 0.8);
    font-family: 'Courier New', monospace;
    /* margin-bottom: 12px; */
}

.options-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.option-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 8px 0;
    background: transparent;
    border-radius: 0;
    border: none;
    transition: all 0.2s ease;
    position: relative;
}

.option-item:hover {
    padding-left: 4px;
}

.option-item.option-correct {
    background: transparent;
    border: none;
    box-shadow: none;
}

.option-item.option-correct .option-label {
    color: #2a4a7a;
    font-weight: 600;
}

.option-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    position: relative;
    flex-shrink: 0;
}

/* 問卷類型：數字編號 */
.option-number.number-survey {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    color: rgba(42, 42, 58, 0.5);
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    font-family: 'Courier New', monospace;
    border: none;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.option-number.number-survey.number-selected {
    background: linear-gradient(135deg, #2a4a7a, #3b6ea5);
    color: #ffffff;
    box-shadow: 0 2px 6px rgba(42, 74, 122, 0.3);
}

/* 測驗類型：圓圈和方框 */
.option-shape {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 2px solid rgba(42, 42, 58, 0.3);
    transition: all 0.2s ease;
    flex-shrink: 0;
    position: relative;
}

.option-shape.shape-circle {
    border-radius: 50%;
}

.option-shape.shape-square {
    border-radius: 4px;
}

.option-shape.shape-selected {
    background: linear-gradient(135deg, #2a4a7a, #3b6ea5);
    border-color: #2a4a7a;
    box-shadow: 0 2px 6px rgba(42, 74, 122, 0.3);
}

.shape-check {
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    font-family: 'Courier New', monospace;
    line-height: 1;
}

.option-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.option-label {
    font-size: 14px;
    font-weight: 500;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    line-height: 1.5;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.correct-checkmark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background: #ffffff;
    color: #52c41a;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    flex-shrink: 0;
    border: 2px solid #52c41a;
    box-shadow: 0 2px 4px rgba(82, 196, 26, 0.2);
}

/* 維度列表樣式（小卡片呈現） */
.dimensions-info-item {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgba(42, 74, 122, 0.2);
}

.dimensions-cards-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    margin-top: 12px;
}

.dimension-card {
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95),
        rgba(248, 249, 250, 0.9)
    );
    border: 1px solid rgba(42, 74, 122, 0.2);
    border-radius: 12px;
    padding: 16px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(42, 74, 122, 0.1);
}

.dimension-card:hover {
    border-color: rgba(42, 74, 122, 0.4);
    box-shadow: 0 4px 12px rgba(42, 74, 122, 0.2);
    transform: translateY(-2px);
}

.dimension-card-header {
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px dashed rgba(42, 74, 122, 0.2);
}

.dimension-card-name {
    font-size: 16px;
    font-weight: 700;
    color: rgba(42, 74, 122, 0.9);
    font-family: 'Courier New', monospace;
    margin-bottom: 6px;
}

.dimension-card-description {
    font-size: 12px;
    color: rgba(42, 42, 58, 0.6);
    font-family: 'Courier New', monospace;
    line-height: 1.5;
}

.dimension-card-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.dimension-weights-summary {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.weight-summary-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: rgba(42, 74, 122, 0.05);
    border: 1px solid rgba(42, 74, 122, 0.15);
    border-radius: 6px;
    transition: all 0.2s ease;
}

.weight-summary-item:hover {
    background: rgba(42, 74, 122, 0.1);
    border-color: rgba(42, 74, 122, 0.3);
}

.weight-question-label {
    font-size: 12px;
    font-weight: 600;
    color: rgba(42, 42, 58, 0.7);
    font-family: 'Courier New', monospace;
    min-width: 60px;
}

.weight-option-label {
    font-size: 13px;
    font-weight: 500;
    color: rgba(42, 42, 58, 0.8);
    font-family: 'Courier New', monospace;
    flex: 1;
}

.weight-value {
    font-size: 14px;
    font-weight: 700;
    color: #2a4a7a;
    font-family: 'Courier New', monospace;
    min-width: 50px;
    text-align: right;
}

/* 維度加權顯示樣式 */
.option-dimension-weights {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed rgba(42, 74, 122, 0.2);
}

.dimension-weight-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    background: rgba(42, 74, 122, 0.05);
    border: 1px solid rgba(42, 74, 122, 0.2);
    border-radius: 6px;
}

.dimension-weight-label {
    font-size: 13px;
    font-weight: 600;
    color: rgba(42, 74, 122, 0.9);
    font-family: 'Courier New', monospace;
    min-width: 60px;
}

.dimension-weight-value {
    font-size: 13px;
    font-weight: 700;
    color: #2a4a7a;
    font-family: 'Courier New', monospace;
    min-width: 50px;
    text-align: right;
}

.score-text-inline {
    font-size: 13px;
    font-weight: 600;
    color: #2a4a7a;
    font-family: 'Courier New', monospace;
    letter-spacing: 0.3px;
}

.text-answer-section {
    margin-top: 16px;
}

.text-answer-inline {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-family: 'Courier New', monospace;
}

.answer-checkmark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background: #ffffff;
    color: #52c41a;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    flex-shrink: 0;
    border: 2px solid #52c41a;
    box-shadow: 0 2px 4px rgba(82, 196, 26, 0.2);
}

.text-answer-value {
    font-size: 16px;
    font-weight: 500;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    line-height: 1.5;
}

.no-answer-hint {
    margin-top: 16px;
    padding: 12px 16px;
    background: rgba(255, 168, 122, 0.1);
    border-radius: 8px;
    border: 1px solid rgba(255, 168, 122, 0.3);
    text-align: center;
}

.no-answer-text {
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 168, 122, 0.9);
    font-family: 'Courier New', monospace;
}

.empty-questions {
    text-align: center;
    padding: 80px 24px;
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95),
        rgba(248, 249, 250, 0.9)
    );
    border-radius: 16px;
    box-shadow:
        0 8px 24px rgba(42, 74, 122, 0.15),
        0 0 0 1px rgba(42, 74, 122, 0.1);
}

.empty-icon {
    font-size: 64px;
    margin-bottom: 16px;
}

.empty-text {
    font-size: 16px;
    color: rgba(42, 42, 58, 0.6);
    font-family: 'Courier New', monospace;
}

/* 結果卡模態框樣式 */
.result-cards-modal :deep(.ant-modal-content) {
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.98),
        rgba(248, 249, 250, 0.95)
    );
    border-radius: 16px;
    box-shadow:
        0 12px 48px rgba(42, 74, 122, 0.2),
        0 0 0 1px rgba(42, 74, 122, 0.1);
}

.result-cards-modal :deep(.ant-modal-header) {
    background: transparent;
    border-bottom: 2px solid rgba(42, 74, 122, 0.3);
    padding: 20px 24px;
}

.result-cards-modal :deep(.ant-modal-title) {
    font-family: 'Courier New', monospace;
    font-weight: 700;
    font-size: 20px;
    color: #2a2a3a;
}

.result-cards-modal-content {
    padding: 8px 0;
}

.result-cards-grid-modal {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 24px;
    max-height: 70vh;
    overflow-y: auto;
    padding: 8px;
}

.result-cards-grid-modal::-webkit-scrollbar {
    width: 8px;
}

.result-cards-grid-modal::-webkit-scrollbar-track {
    background: rgba(42, 74, 122, 0.1);
    border-radius: 4px;
}

.result-cards-grid-modal::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #2a4a7a, #3b6ea5);
    border-radius: 4px;
}

.result-cards-grid-modal::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #b86de6, #7a9fef);
}

.result-card-item-modal {
    background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.95),
        rgba(248, 249, 250, 0.9)
    );
    border-radius: 16px;
    padding: 20px;
    box-shadow:
        0 8px 24px rgba(42, 74, 122, 0.15),
        0 0 0 1px rgba(42, 74, 122, 0.1);
    backdrop-filter: blur(10px);
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
}

.result-card-item-modal:hover {
    transform: translateY(-4px);
    box-shadow:
        0 12px 32px rgba(42, 74, 122, 0.25),
        0 0 0 1px rgba(42, 74, 122, 0.2);
}

.result-card-image-wrapper-modal {
    width: 100%;
    margin-bottom: 16px;
    border-radius: 12px;
    overflow: hidden;
    background: rgba(42, 74, 122, 0.05);
    aspect-ratio: 16 / 9;
    display: flex;
    align-items: center;
    justify-content: center;
}

.result-card-image-modal {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.result-card-content-modal {
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1;
}

.result-card-title-modal {
    font-size: 18px;
    font-weight: 700;
    color: #2a2a3a;
    font-family: 'Courier New', monospace;
    margin: 0;
    line-height: 1.4;
}

.result-card-meta-modal {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    flex-wrap: wrap;
}

.result-card-select-mode-modal {
    font-size: 12px;
    color: rgba(42, 42, 58, 0.6);
    font-family: 'Courier New', monospace;
}

.result-card-subtitle-modal {
    font-size: 14px;
    color: rgba(42, 42, 58, 0.7);
    font-family: 'Courier New', monospace;
    margin: 0;
    line-height: 1.6;
}

.result-card-summary-modal {
    font-size: 13px;
    color: rgba(42, 42, 58, 0.6);
    font-family: 'Courier New', monospace;
    margin: 0;
    line-height: 1.6;
    flex: 1;
}

.result-card-description-modal {
    margin-top: 4px;
    font-size: 13px;
    color: rgba(42, 42, 58, 0.75);
    font-family: 'Courier New', monospace;
    line-height: 1.8;
    white-space: pre-wrap;
}

.result-card-detail-html {
    margin-top: 8px;
    padding: 10px 12px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(42, 74, 122, 0.25);
    max-height: 260px;
    overflow-y: auto;
    font-family: 'Courier New', monospace;
}

.result-card-detail-html :deep(h3),
.result-card-detail-html :deep(h4) {
    margin: 0 0 8px;
    font-weight: 700;
    color: #2a2a3a;
}

.result-card-detail-html :deep(p) {
    margin: 0 0 8px;
    line-height: 1.7;
    color: rgba(42, 42, 58, 0.8);
}

.result-card-detail-html :deep(ul) {
    padding-left: 20px;
    margin: 0 0 8px;
}

.result-card-detail-html :deep(li) {
    margin-bottom: 4px;
}

.result-card-dimension-modal {
    margin-top: auto;
    padding-top: 12px;
    border-top: 1px solid rgba(42, 74, 122, 0.2);
}

.no-result-cards {
    text-align: center;
    padding: 60px 20px;
    color: rgba(42, 42, 58, 0.5);
    font-family: 'Courier New', monospace;
}
</style>
